export default __webpack_public_path__ + "static/media/building.570ccc42.svg";